export const emailTypeMap = [
  {
    type: 'Work',
    field: 'workEmail',
  },
  {
    type: 'Spouse',
    field: 'spouseEmail',
  },
  {
    type: 'Personal',
    field: 'personalEmail',
  },
];

export default { emailTypeMap };